<template>
  <div class="radio-button-container" :class="button_disabled">
    <input type="checkbox" class="radio-button-checkbox" :class="group" v-on:click="check" radio ref="radioCheckbox"></input>
    <div class="radio-button" :class="[type, is_correct]">
      <div class="radio-button-indicator" :class="[type, is_correct]"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['type', 'correct', 'caption', 'title', 'group', 'groupQuestion'],
    data () {
      return {
        el: ''
      }
    },
    methods: {
      uncheckAll () {

        let checkboxes = document.querySelectorAll('input.radio-button-checkbox')

        if (this.group) {
          checkboxes = document.querySelectorAll('input.radio-button-checkbox.' + this.group)
        }

        for(var i = 0; i < checkboxes.length; i ++) {
          checkboxes[i].checked = false
        }
      },
      groupStoreCallback (bool) { // group cb to push or remove value from store
        if (!this.group) return

        // set validations
        this.$store.commit('setPreSurvey', {
          [this.group]: bool
        })

        // todo: add values (question, response) as well.]

        // set data
        if (bool) {
          this.$store.commit('setPreSurveyData', {
            question: this.groupQuestion,
            response: this.title
          })
        }
        
      },
      check () {
        let store = this.$store.state.checkbox.el
        let el = this.$el
        let snapshot = this.$refs.radioCheckbox.checked // capture state before unchecking

        this.uncheckAll()

        if (snapshot) { // if checked
          this.$refs.radioCheckbox.checked = true
          this.groupStoreCallback(true)
        } else {
          this.$refs.radioCheckbox.checked = false
          // group cb to push or remove value from store
          this.groupStoreCallback(false)
        }

        // return and skip below if/else sequence if on pre-survey.
        if (this.group) return // group attr is only used on pre-survey
        
        // for quiz pages only
        if (store === el) {
          this.$store.commit('set_checkbox', {el: null})
          this.$store.commit('set_navigation_next', {
            custom: 'button-disabled'
          })
        } else {
          this.$store.commit('set_checkbox', {el, correct: this.set_correct, caption: this.caption})
          this.$store.commit('set_navigation_next', {
            custom: ''
          })
        }

      }
    },
    computed: {
      button_disabled () {
        let store = this.$store.state.checkbox.el
        let el = this.el
        if (store && el !== store) {
          // return 'inactive'
          return ''
        }
      },
      set_correct () {
        // todo: refactor to only use one method.
        if (!this.correct) return 'incorrect'
        return 'correct'
      },
      is_correct () {
        // show all correct and incorrect on correct notification popup.
        // if no checkbox or no notification return
        if (!this.$store.state.checkbox.el || !this.$store.state.notification_state.active) return ''
        // if incorrect and the checkbox is not this one, return
        if (this.$store.state.checkbox.correct !== 'correct' && this.$store.state.checkbox.el !== this.$el) return ''
        // else, show green or red colors
        if (!this.correct) return 'incorrect'
        return 'correct'
      }
    },
    mounted () {
      this.el = this.$el
    }
  }
</script>

<style scoped lang="scss">

  @import '../../styles/variables';

  .radio-button-container {
    position: relative;
    margin: 12px;
    width: 24px;
    height: 24px;
    transition: opacity $transition-1;
    &.inactive {
      opacity: 0.4;
      pointer-events: none;
    }
  }

  .radio-button-checkbox {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    cursor: pointer;
    width: 100%;
    height: 100%;
    opacity: 0;
    &:hover {
      + .radio-button {
        background-color: transparent;
      }
    }
    &:checked {
      + .radio-button {
        border: 1px solid $blue;
        .radio-button-indicator {
          opacity: 1;
        }
      }
    }
  }

  .radio-button {
    position: relative;
    z-index: 1;
    display: flex;
    width: 100%;
    height: 100%;
    background-color: $light-blue;
    border: 1px solid $light-black;
    border-radius: 50%;
    transition: all $transition-1;
    &.incorrect {
      border: 1px solid $red !important;
    }
    &.correct {
      border: 1px solid $green !important;
    }
  }

  .radio-button-indicator {
    position: relative;
    margin: auto;
    opacity: 0;
    pointer-events: none;
    width: 18px;
    height: 18px;
    background-color: $blue;
    border-radius: 50%;
    transition: all $transition-1;
    &.incorrect {
      opacity: 1;
      background-color: $red !important;
    }
    &.correct {
      opacity: 1;
      background-color: $green !important;
    }
  }

</style>




// WEBPACK FOOTER //
// radio.vue?6f5acf7f